// eslint-disable-next-line import/prefer-default-export
export enum TestTypes {
    None = '',
    Skills = 'Skills',
    Aptitude = 'Aptitude',
    Personality = 'Personality',
    EmotionalIntelligence = 'EmotionalIntelligence',
}
